import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import NewProject from "@/pages/NewProject";
import ProjectDetail from "@/pages/ProjectDetail";
import Normative from "@/pages/Normative";
import Glossary from "@/pages/Glossary";
import Simulator from "@/pages/Simulator";
import ConventionModels from "@/pages/ConventionModels";
import Comparator from "@/pages/Comparator";
import Jurisprudence from "@/pages/Jurisprudence";
import Presentation from "@/pages/Presentation";
import AuditLog from "@/pages/AuditLog";
import Invite from "@/pages/Invite";
import NetworkDashboard from "@/pages/NetworkDashboard";
import Visualizations from "@/pages/Visualizations";
import Diagnostics from "@/pages/Diagnostics";
import Library from "@/pages/Library";
import Analyses from "@/pages/Analyses";
import Placeholder from "@/pages/Placeholder";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <Toaster position="top-right" richColors closeButton />
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/invite/:token" element={<Invite />} />

              {/* Protected */}
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/new" element={<NewProject />} />
                <Route path="/projects/:id" element={<ProjectDetail />} />
                <Route path="/library" element={<Library />} />
                <Route path="/normative" element={<Normative />} />
                <Route path="/jurisprudence" element={<Jurisprudence />} />
                <Route path="/analyses" element={<Analyses />} />
                <Route path="/diagnostics" element={<Diagnostics />} />
                <Route path="/visualizations" element={<Visualizations />} />
                <Route path="/reports" element={<Placeholder title="Rapports" subtitle="Ouvrez un projet pour générer un rapport." testid="reports-page" />} />
                <Route path="/simulator" element={<Simulator />} />
                <Route path="/comparator" element={<Comparator />} />
                <Route path="/models" element={<ConventionModels />} />
                <Route path="/glossary" element={<Glossary />} />
                <Route path="/audit" element={<AuditLog />} />
                <Route path="/network" element={<NetworkDashboard />} />
                <Route path="/settings" element={<Placeholder title="Paramètres" subtitle="Profil utilisateur et préférences." testid="settings-page" />} />
              </Route>

              {/* Présentation full-screen (no Layout) */}
              <Route path="/projects/:id/presentation" element={
                <ProtectedRoute><Presentation /></ProtectedRoute>
              } />

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
